
import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Router } from 'react-router-dom';
import history from './history';
import Store from './store'
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { cyan } from "@material-ui/core/colors";


const theme = createMuiTheme({
    palette: {
        typography: {
            useNextVariants: true,
        },
        primary: {
            main: cyan[500],
            contrastText: '#fff',
        },
        secondary: {
            main: '#11cb5f'
        }
    }
});


const rootElement = document.getElementById('root');

ReactDOM.render(
    <Provider store={Store} >
        <Router history={history}>
            <MuiThemeProvider theme={theme}>
                <App />
                <ToastContainer />
            </MuiThemeProvider>
        </Router>
    </Provider>
    , rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
